import React from 'react';

/**
 * A rich message of react-intl (a `<b>` part, an element value) is an array of text and elements.
 * Rendered as an array, React 19 warns "Each child in a list should have a unique key", also after
 * `Children.toArray`. Spread into one fragment, the parts are fixed children and need no key.
 */
export function richTextChildren(node: React.ReactNode): React.ReactNode {
  return Array.isArray(node) ? React.createElement(React.Fragment, null, ...(node as React.ReactNode[])) : node;
}

/** The text of the chunks of a rich part, for its key. Pure. */
function chunkText(chunks: React.ReactNode[]): string {
  return chunks.map((chunk) => (typeof chunk === 'string' || typeof chunk === 'number' ? String(chunk) : '')).join('');
}

/**
 * The `<b>` part of a rich message (`{ b: boldPart }`). Its key is its text, so a message with
 * several bold parts gives no "two children with the same key" error, as one fixed key "b" did
 * (QA 2026-10-28, skpr2-3).
 */
export function boldPart(chunks: React.ReactNode[]): React.ReactElement {
  return React.createElement('b', { key: `b-${chunkText(chunks)}` }, ...chunks);
}
